export interface AvisoObraItem {
    nroObra: string;
    direccion: string;
    localidad: string;
    provincia: string;
    programa: string;
    tipoObra: string;
    fechaInicio: string;
    fechaFin: string;
    idEstado: number;
    fechaAlta: string;
}

export interface AvisoObraResponse {
    data: {
        data: AvisoObraItem[];
        total: number;
    };
}

export const ACTION_TYPES = {
    SUSPEND: 'Suspender',
    EXTEND: 'Extender',
    RESTART: 'Reiniciar',
    DEREGISTER: 'Baja',
    UPLOAD_PDF_PROGRAMA: 'Subir Programa de Seguridad',
    RECEIVE_PROGRAMA: 'Recepción Programa de Seguridad',
    APPROVE_PROGRAMA: 'Aprobación Programa de Seguridad',
    CONFIRM_DEREGISTER: 'Confirmar Baja'
} as const;

export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];

export interface ExtensionFormData {
    fechaExtension: string;
}

export interface SuspensionFormData {
    fechaSuspension: string;
    fechaReinicio: string;
}
